import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "@reach/router";
import classNames from "classnames";
import Heading from "~/scripts/components/Heading";
import RollTitle from "~/scripts/components/RollTitle";
import * as ease from "~/scripts/utils/ease";
import { isMobile } from "~/scripts/utils/is-mobile";
import { w } from "~/scripts/utils/w";
import { debounce } from "lodash";
import { af } from "@gladeye/af";

// Links mask / select start
const startProgress = -0.3;
const endProgress = 1.3;

class IndexRoll extends Component {
    static propTypes = {
        directors: PropTypes.array,
        posY: PropTypes.number
    };

    scrollTimeoutID = null;
    userScroll = true;
    listRect = null; // Rect element for list
    selected;

    state = {
        oldScroll: null
        // listRect: null
    };

    constructor(props) {
        super(props);
        this.af = af();
        this.w = w();
        this.listRef = React.createRef();
        this.handleResize = debounce(this.handleResize, 250);
    }

    // read = () => {
    //     if (this.listRef && this.listRef.current) {
    //         this.listRect = this.listRef.current.getBoundingClientRect();
    //     }
    // };

    // write = () => {
    //     const { listRect } = this;

    //     if (listRect) {
    //         this.setState({ listRect });
    //     }
    // };

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        // this.af.addRead(this.read);
        // this.af.addWrite(this.write);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleResize);
        // this.af.removeRead(this.read);
        // this.af.removeWrite(this.write);
    }

    componentDidUpdate(prevProps) {
        const { directors } = this.props;

        // if (prevProps.directors !== directors) {
        //     this.links = Array(directors.length).fill({});
        // }
    }

    handleResize = () => {
        this.selectInPosition();
    };

    handleScroll = () => {
        if (isMobile) {
            const { pageYOffset } = window;
            const { oldScroll } = this.state;

            if (oldScroll !== pageYOffset) {
                // console.log(pageYOffset);
                this.setState({
                    oldScroll: pageYOffset
                });
            }
        } else {
            // If it was user who scrolled
            if (this.userScroll) {
                clearTimeout(this.scrollTimeoutID); // Reset timeout
                this.scrollTimeoutID = setTimeout(this.selectInPosition, 300); // Wait 300ms before selecting an item
            } else {
                this.userScroll = true;
            }
        }
    };

    handleClick = (e, index) => {
        if (!isMobile) {
            const { selected } = this;
            const { toggleSpecialPageTransition } = this.props;

            // If Index of clicked element is not selected one,
            // select it first before activating the link
            if (selected !== index) {
                e.preventDefault();
                this.select(index);
            } else {
                toggleSpecialPageTransition(true);
            }
        }
    };

    // Calculate progress for a given link
    // Uses current .top position of link and it's .height
    calcProgress = (top, height) => {
        let progress = (this.w.h / 2 - top) / height;
        progress = Math.round(progress * 1000) / 1000;

        return progress;
    };

    // Find item that is in the middle of the page, according to TRUE scroll (not scroll jacked value)
    // If found one -> select / scroll to it
    selectInPosition = () => {
        // Don't select in position for mobile
        if (isMobile) return;

        const { pageYOffset } = window;
        const { posY, directors } = this.props;

        if (typeof directors === "undefined") return;
        if (this.listRect === null) return;

        let found = -1;
        const height = this.listRect.height / directors.length;

        for (let i = 0; i < directors.length; i++) {
            // Calculate .top if page was at TRUE scroll position
            const top = posY + this.listRect.top + height * i - pageYOffset;

            // Calculate progress if page was at TRUE scroll position
            const progress = this.calcProgress(top, height);

            // Return if progress inbetween 0 and 1
            // If first pr last item, allow extra progress to be selected
            const start = i === 0 ? startProgress : 0;
            const end = i === directors.length - 1 ? endProgress : 1;

            if (progress >= start && progress <= end) {
                found = i;
                break;
            }
        }

        // If element found at true scroll position, select it
        if (found !== -1) {
            this.select(found);
        } else {
            this.selected = null;
        }
    };

    // Select & scroll to element by index
    select = index => {
        const { posY, directors } = this.props;
        const height = this.listRect.height / directors.length;
        const top = this.listRect.top + height * index;

        // Get Y position relative to animated page
        const y = posY + top - this.w.h / 2 + height / 2;

        // Make sure next window scroll event doesn't register as human
        this.userScroll = false;
        window.scrollTo(0, y);

        // Set selected item to index
        this.selected = index;
    };

    rangeProgress = (progress, start, end) => {
        return (progress - start) / (end - start);
    };

    renderDirector = (director, index) => {
        const { state, headingPos, directors } = this.props;
        const { listRect } = this;
        let maskY = 500;
        let imgY = 0;
        let current = null;
        let transitionY = 0;
        let progress = null;

        // If ref exists
        if (listRect && listRect.height > 0 && !isMobile) {
            const height = listRect.height / directors.length;
            const top = listRect.top + height * index;

            // Calculate progress
            progress = this.calcProgress(top, height);
            const eased = ease.linear(progress);

            // Set current Link being scrolled through (in the middle)
            if (progress >= 0 && progress <= 1) current = index;

            // Mask
            maskY = Math.min(Math.max(eased, startProgress), endProgress);
            maskY = this.rangeProgress(maskY, startProgress, endProgress);
            maskY = 1 - maskY * 2;
            // maskY = maskY;
            maskY = height * maskY;

            // Image parallax
            imgY = Math.min(Math.max(eased, -1), 2);
            imgY = 1 - imgY * 2;
            imgY = imgY * 50;

            // TransitionY for the title when changing page
            if (headingPos) {
                transitionY = Math.round(headingPos.height - top);
            }
        }

        const isSelected = this.selected === index;
        const uri = "/" + director.uri;
        return (
            <Link
                className={`index-roll__link ${
                    current === index ? "is-current" : ""
                } ${progress && progress > 1 ? "is-next" : ""} ${
                    progress && progress < 0 ? "is-prev" : ""
                }`}
                onClick={e => this.handleClick(e, index)}
                to={uri}
                key={director.id}
            >
                <div
                    className="index-roll__title-wrap"
                    style={{
                        transform:
                            state === "exiting" && current !== null
                                ? `translate3d(0, ${transitionY}px, 0)`
                                : ""
                    }}
                >
                    <Heading outline={true} className="index-roll__title">
                        {director.title}
                    </Heading>
                    <div
                        className="index-roll__mask"
                        style={{
                            transform: isMobile
                                ? ""
                                : `translate3d(0, ${-maskY}px, 0)`
                        }}
                    >
                        <div
                            className="index-roll__mask-content"
                            style={{
                                transform: isMobile
                                    ? ""
                                    : `translate3d(0, ${maskY}px, 0)`
                            }}
                        >
                            <Heading
                                outline={false}
                                className="index-roll__title"
                            >
                                {director.title}
                            </Heading>
                        </div>
                    </div>
                </div>

                <div className="index-roll__image-container">
                    <div
                        className="index-roll__parallax-container"
                        style={{
                            transform: isMobile
                                ? ""
                                : `translate3d(0, ${-imgY}px, 0)`
                        }}
                    >
                        <picture className="index-roll__image">
                            <source
                                media="(max-width: 900px)"
                                srcSet={
                                    isSelected
                                        ? director.poster.mobile
                                        : director.poster.thumb
                                }
                            />
                            <img
                                src={
                                    isSelected
                                        ? director.poster.desktop
                                        : director.poster.thumb
                                }
                                alt={director.title}
                            />
                        </picture>
                    </div>
                </div>
            </Link>
        );
    };

    render() {
        const { directors, isProducer } = this.props;

        if (this.listRef && this.listRef.current) {
            this.listRect = this.listRef.current.getBoundingClientRect();
        }

        const title = isProducer ? "Line Producers" : "Directors";

        return (
            <div className="index-roll">
                <div className="index-roll__title">
                    <RollTitle>{title}</RollTitle>
                </div>

                <div className="index-roll__list" ref={this.listRef}>
                    {directors && directors.map(this.renderDirector)}
                </div>
            </div>
        );
    }
}

export default IndexRoll;



// WEBPACK FOOTER //
// ./src/scripts/components/IndexRoll.js